export const failureHash = {
    AFFILIATE_CUSTOM_CODE_ALREADY_EXISTS: "API__EP__BILLING__AFFILIATE_CUSTOM_CODE_ALREADY_EXISTS",
};
//# sourceMappingURL=affiliate.static.js.map